import React from 'react';
import { createRoot } from 'react-dom/client';
import parseDataToProps from 'js/utilities/parseDataToProps';

const nodes = document.querySelectorAll('[data-country-language-switch]');

if (nodes.length) {
    import('./components/CountryLanguageSwitch').then(({ default: CountryLanguageSwitch }) => {
        nodes.forEach((node) => {
            const root = createRoot(node);
            root.render(<CountryLanguageSwitch {...parseDataToProps(node.dataset)} />);
        });
    });
}
